/** URL state shared by browser history, native tabs, refresh and universal links. */
export function readShellLocation(href: string) {
  const url = new URL(href);
  const site = url.searchParams.get("site"), day = url.searchParams.get("day");
  const requestedTab = url.searchParams.get("tab") || "site:0";
  return {
    target: { seg: site ? `site:${site}` : day || "today", isToday: !site && !day, siteId: site },
    tab: ["friends", "profile", "site:0", "site:1", "site:2"].includes(requestedTab) ? requestedTab : "site:0",
    hash: url.hash,
  };
}

export function tabURL(href: string, tab: string) {
  const url = new URL(href);
  if (tab === "site:0") url.searchParams.delete("tab");
  else url.searchParams.set("tab", tab);
  return url.pathname + url.search + url.hash;
}

export function shareDayURL(href: string, day: string) {
  const url = new URL(href);
  // A shared day stays on that day tomorrow. Preview links retain their site ID.
  if (!url.searchParams.has("site")) url.searchParams.set("day", day);
  const tab = url.searchParams.get("tab");
  if (tab === "friends" || tab === "profile") url.searchParams.delete("tab");
  return url.href;
}

/**
 * Deep links into a day's site travel as one URL fragment so notifications, the inbox and universal links can
 * carry them on every client: "#post/abc" opens the site's first tab at route "post/abc"; "#~feed/post/abc"
 * opens tab "feed" (a meta.json tab id) at that route. Written by src/sandbox.ts notifyRecipient.
 */
export function parseDeepLink(hash: string): { tab: string | null; route: string } {
  const h = hash.replace(/^#/, "");
  const m = /^~([a-z0-9_-]{1,20})(?:\/(.*))?$/i.exec(h);
  return m ? { tab: m[1], route: m[2] || "" } : { tab: null, route: h };
}

export function deepLinkHash(tab: string | null | undefined, route: string): string {
  const r = route.replace(/^[#/]+/, "");
  return tab ? `#~${tab}/${r}` : r ? `#${r}` : "";
}

/** The current day's shell URL (keeps ?day / ?site, drops the tab) opened at a deep link. */
export function dayLinkURL(href: string, hash: string) {
  const url = new URL(href);
  url.searchParams.delete("tab");
  url.hash = hash;
  return url.pathname + url.search + url.hash;
}

/** Load the existing profile route as its own tab root, independently of the feed/composer frames. */
export function profileFrameURL(sandboxOrigin: string, day: string, profile: { tab?: string; route: string }, userId: string, version: number) {
  const route = profile.route.replace("{id}", encodeURIComponent(userId));
  const query = new URLSearchParams({ v: String(version), root: route });
  if (profile.tab) query.set("tab", profile.tab);
  return `${sandboxOrigin}/sandbox/${day}/?${query}#${route}`;
}
